import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

// Public Pages
import Home from "@/pages/Home";
import WhatWeDo from "@/pages/WhatWeDo";
import WhoWeServe from "@/pages/WhoWeServe";
import VeteranSupport from "@/pages/VeteranSupport";
import WhyThisMatters from "@/pages/WhyThisMatters";
import WorkforceEmpowerment from "@/pages/WorkforceEmpowerment";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import RequestSupport from "@/pages/RequestSupport";
import PartnerWithUs from "@/pages/PartnerWithUs";
import Contact from "@/pages/Contact";
import LegalPolicy from "@/pages/LegalPolicy";
import PrivacyPolicy from "@/pages/PrivacyPolicy";

// Admin Pages
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminBlog from "@/pages/admin/AdminBlog";
import AdminBlogEditor from "@/pages/admin/AdminBlogEditor";
import AdminComments from "@/pages/admin/AdminComments";
import AdminContacts from "@/pages/admin/AdminContacts";
import AdminSupportRequests from "@/pages/admin/AdminSupportRequests";
import AdminPartnerships from "@/pages/admin/AdminPartnerships";

// Layout Components
import PublicLayout from "@/components/layout/PublicLayout";
import AdminLayout from "@/components/layout/AdminLayout";
import ProtectedRoute from "@/components/auth/ProtectedRoute";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/what-we-do" element={<WhatWeDo />} />
            <Route path="/who-we-serve" element={<WhoWeServe />} />
            <Route path="/veteran-support" element={<VeteranSupport />} />
            <Route path="/why-this-matters" element={<WhyThisMatters />} />
            <Route path="/workforce-empowerment" element={<WorkforceEmpowerment />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/request-support" element={<RequestSupport />} />
            <Route path="/partner-with-us" element={<PartnerWithUs />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/legal-policy" element={<LegalPolicy />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          </Route>

          {/* Admin Login */}
          <Route path="/admin/login" element={<AdminLogin />} />

          {/* Protected Admin Routes */}
          <Route element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/blog" element={<AdminBlog />} />
            <Route path="/admin/blog/new" element={<AdminBlogEditor />} />
            <Route path="/admin/blog/edit/:id" element={<AdminBlogEditor />} />
            <Route path="/admin/comments" element={<AdminComments />} />
            <Route path="/admin/contacts" element={<AdminContacts />} />
            <Route path="/admin/support-requests" element={<AdminSupportRequests />} />
            <Route path="/admin/partnerships" element={<AdminPartnerships />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;